module.exports = __webpack_public_path__ + "img/phone.343110a.png";